/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import getSitemapSettings, { getSitemaps } from '@apps/config/API/sitemap';
import SitemapScreen from '@apps/screens/Sitemap';
import { Breadcrumb } from '@stack/ui/components';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  // ======================= HOOKS
  const { sitemapSettings, sitemaps } = props;
  const router = useRouter();
  const { query } = router;
  const { lang, t } = useTranslation('common');

  // const newLang = localeConversions(lang);

  // ======================= STATE
  const [loading, setloading] = useState<boolean>(false);
  const [data, setData] = useState<any>(sitemaps);
  const [currentPage, setCurrentPage] = useState(1);
  const yearQuery = (query?.year as string) ?? null;
  const monthQuery = (query?.month as string) ?? null;

  // ======================= API
  const fetchData = async (pageNumber: number) => {
    try {
      const year = parseInt(router.query?.year as string) ?? '';
      const month = parseInt(router.query?.month as string) ?? null;

      setloading(true);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' as any,
        });
      }, 0);

      const res = await getSitemaps({
        page: pageNumber,
        year,
        month,
      });
      // if (res.data.length < 1) {
      //   router.replace(webView ? '/webview/404' : '/404');
      //   return;
      // }

      setData(res);
      setloading(false);
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    const { page } = router.query;
    fetchData(parseInt(page as string) || 1);
    setCurrentPage(parseInt(page as string) || 1);
  }, [router?.asPath, router?.locale]);

  // ======================= VARIABLES
  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: t('news'),
      url: '/',
    },
    {
      title: t('sitemap'),
    },
  ];

  const currentUrl =
    lang === 'en'
      ? `${BASE_URL}${router?.asPath}`
      : `${BASE_URL}/${lang}${router?.asPath}`;
  const cleanedPath = currentUrl.split('?')[0].toLowerCase();
  const hrefUrl =
    '/browse-by-year/' +
    (yearQuery ? yearQuery : '') +
    (monthQuery ? `?month=${monthQuery}` : '');

  // ======================= VIEWS
  return (
    <>
      <NextSeo canonical={cleanedPath} />
      <SEOLocaleList />
      <div>
        <Breadcrumb options={breadcrumbOpt} />
        <SitemapScreen
          sitemapSettings={sitemapSettings}
          sitemaps={data}
          currentPage={currentPage}
          loading={loading}
          href={hrefUrl}
        />
      </div>
    </>
  );
};

export async function getServerSideProps(ctx: NextPageContext) {
  const sitemapSettings = await getSitemapSettings();
  const years = sitemapSettings?.year;

  const year = ctx.query?.year ?? years.pop();
  const month = parseInt(ctx.query?.month as string) ?? null;
  const sitemaps = await getSitemaps({ page: 1, year, month });

  return {
    props: {
      sitemapSettings,
      sitemaps,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
